module.exports = __webpack_public_path__ + "img/spezialitaetentellermithintergrund.4f3a6289.jpg";